import { Reveal } from "./Reveal";
import { IMAGES, TESTIMONIALS } from "../lib/content";
import { Quote } from "lucide-react";

export const TrustJaipur = () => (
  <section data-testid="trust" className="relative py-24 lg:py-32 overflow-hidden">
    <div className="absolute inset-0">
      <img
        src={IMAGES.jaipur}
        alt="Jaipur architecture"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-brand-ink/70" />
    </div>

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 text-brand-cream">
      <Reveal>
        <p className="text-xs font-semibold tracking-[0.25em] text-brand-gold uppercase mb-5">
          Rooted in Jaipur
        </p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-3xl">
          A local family, for the family that lives far away.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div
              data-testid={`testimonial-${i}`}
              className="h-full rounded-3xl bg-white/10 backdrop-blur-md border border-white/15 p-8"
            >
              <Quote className="text-brand-gold mb-5" size={28} />
              <p className="font-serif text-2xl sm:text-3xl leading-snug mb-6">
                {t.quote}
              </p>
              <div className="text-sm">
                <p className="font-semibold">{t.name}</p>
                <p className="text-brand-cream/60">{t.role}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
